import React from 'react'

const NoMatch = ()=> {
  return (
    <div style={{ padding: 20 }}>
        <h2>404: Page Not Found</h2>
    </div>
  );
};

export default NoMatch